import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const donationsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.DONATIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.DONATIONS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.DONATIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { donationsReducer };
